import * as React from 'react'
import { cn } from '@/lib/utils'

// Callout — riquadro informativo del Design system .italia (Designers Italia):
// bordo perimetrale + spessa barra laterale e titolo maiuscolo nel colore della variante.
type CalloutVariant = 'note' | 'warning' | 'danger' | 'success'

const variants: Record<CalloutVariant, { wrap: string; title: string }> = {
  note: {
    wrap: 'border-mim-blue/25 border-l-mim-blue bg-mim-lightblue/40 dark:bg-primary/10 dark:border-primary/40 dark:border-l-primary',
    title: 'text-mim-blue dark:text-primary',
  },
  warning: {
    wrap: 'border-giallo/30 border-l-giallo bg-giallo-light/50 dark:bg-giallo/10',
    title: 'text-giallo-dark dark:text-giallo',
  },
  danger: {
    wrap: 'border-rosso/30 border-l-rosso bg-rosso-light/50 dark:bg-rosso/10',
    title: 'text-rosso-dark dark:text-rosso',
  },
  success: {
    wrap: 'border-verde/30 border-l-verde bg-verde-light/50 dark:bg-verde/10',
    title: 'text-verde-dark dark:text-verde',
  },
}

export interface CalloutProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  variant?: CalloutVariant
  title?: React.ReactNode
  icon?: React.ReactNode
}

export function Callout({
  variant = 'note',
  title,
  icon,
  className,
  children,
  ...props
}: CalloutProps) {
  const v = variants[variant]
  return (
    <div
      className={cn('rounded-md border border-l-4 px-4 py-3.5', v.wrap, className)}
      {...props}
    >
      {title && (
        <div
          className={cn(
            'flex items-center gap-2 text-xs font-bold uppercase tracking-wider mb-1.5',
            v.title
          )}
        >
          {icon && <span className="flex-shrink-0">{icon}</span>}
          <span>{title}</span>
        </div>
      )}
      <div className="text-sm text-foreground/90 leading-relaxed">{children}</div>
    </div>
  )
}
